import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface AuthenticationErrorProps {
  message: string;
  // Retained for callers that still expect to pass it; not used directly any
  // more. We route through /account/logout so this path goes through the same
  // teardown as the regular logout: end impersonation session, clear storage,
  // then sign out.
  signOut?: () => void;
}

export const AuthenticationError: React.FC<AuthenticationErrorProps> = ({ message }) => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/account/logout');
  };

  return (
    <Wrapper>
      <Container>
        <Icon 
          name="exclamation circle" 
          size="huge"
          style={{ 
            color: '#e74c3c', 
            marginBottom: '24px' 
          }}
        />
        
        <Title>Access Denied</Title>
        
        <Message>{message}</Message>
        
        <Button 
          onClick={handleBackToLogin} 
          primary 
          size="large"
          style={{ 
            minWidth: '200px',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 500
          }}
        >
          Back to Login
        </Button>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
`;

const Container = styled.div`
  background: white;
  padding: 48px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  font-family: 'Poppins', sans-serif;
`;

const Message = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 32px;
  font-family: 'Poppins', sans-serif;
`;

